/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore'], function(backbone, _) {
    var OptionModel;

    return (OptionModel = backbone.Model.extend(
        {
            defaults: {
                name: null,
                title: null,
                price: 0,
                visible: true,
                required: false,
                optionValues: []
            },
            initialize: function(options) {
                this.set('optionValues', new backbone.Collection());
            },

            getOptionValue: function(optionValueName) {
                return this.get('optionValues').findWhere({ name: optionValueName });
            },

            /**
             * @param {Object} options
             * @returns {OptionValueModel}
             */
            fromDTO: function(options) {
                var _this = this;
                _.each(OptionModel.DTOMap, function(mappedName, attributeName) {
                    if (options[mappedName] !== undefined) {
                        _this.set(attributeName, options[mappedName]);
                    }
                });
                return this;
            }
        },
        {
            DTOMap: {
                name: 'name',
                title: 'title',
                price: 'price',
                required: 'required',
                visible: 'visible'
            },

            NAME_BACK_COATING: 'back_coating',
            NAME_BACK_FOIL_COLOR: 'back_foil_color',
            NAME_BINDING: 'binding',
            NAME_CORNERS: 'rc',
            NAME_COVER_COATING: 'cover_coating',
            NAME_COVER_SUBSTRATE: 'cover_substrate',
            NAME_ENVELOPE: 'envelope',
            NAME_FILLING: 'filling',
            NAME_FOLDING: 'folding',
            NAME_FRONT_COATING: 'front_coating',
            NAME_FRONT_FOIL_COLOR: 'front_foil_color',
            NAME_HOLE_DRILLING: 'hole_making',
            NAME_MAILING_SERVICE: 'mailing_service',
            NAME_MAGNETS: 'magnets',
            NAME_SCORING: 'scoring',
            NAME_SUBSTRATE: 'substrate',
            NAME_THICKNESS: 'thickness',
            NAME_TRIMMING: 'trimming',
            NAME_UPLOAD_PATTERN: 'upload_pattern',
            NAME_T_SHIRT_COLOR: 'shirt-color',
            NAME_T_SHIRT_SIZE: 'shirt-size',
            NAME_FRONT_SPOT_UV_COVERAGE: 'front-spot-uv-coverage',
            NAME_BACK_SPOT_UV_COVERAGE: 'back-spot-uv-coverage',
            NAME_CLOSURE_TYPE: 'closure_type',
            NAME_CASE_COLOR: 'case-colour'
        }
    ));
});
